import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { LOGOS } from "@/lib/brand";

export default function AdminLogin() {
  const { user, ready, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (ready && user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error || "Identifiants invalides");
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 pt-24 pb-12" data-testid="page-admin-login">
      <div className="w-full max-w-md rounded-xl border border-white/10 bg-[#0e0e0e] p-10">
        <img src={LOGOS.groupe} alt="Equinoxe" className="h-16 w-16 object-contain mx-auto" />
        <div className="text-center mt-6">
          <div className="text-xs uppercase tracking-[0.3em] text-zinc-500">Espace</div>
          <h1 className="font-display text-3xl font-bold mt-2 flex items-center justify-center gap-2">
            <Lock size={20} /> Administration
          </h1>
        </div>

        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-zinc-500">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              required
              className="mt-2 w-full bg-[#141414] border border-white/10 rounded-md px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-white/30"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-zinc-500">Mot de passe</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
              required
              className="mt-2 w-full bg-[#141414] border border-white/10 rounded-md px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-white/30"
            />
          </div>

          {error && (
            <div className="text-sm text-red-400" data-testid="admin-login-error">{error}</div>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-white text-black font-semibold disabled:opacity-60"
          >
            {loading && <Loader2 className="animate-spin" size={16} />}
            Se connecter
          </button>
        </form>
      </div>
    </div>
  );
}
